import React, { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { type BreadcrumbItem, BreadcrumbProvider, useBreadcrumbs } from '@dxaas/frontend-core'

import { Header } from '@/components/layout'
import { useAplicacionActiva } from '@/hooks/useAplicacionActiva'

// TDD-035 — Header presente, sin Sidebar, ancho completo. Usado por la home
// page (Workspace) y por vistas que necesiten aprovechar todo el ancho de
// pantalla (dashboards, planillas) manteniendo la navegación de plataforma
// (breadcrumb, about, ayuda) visible.
// TDD-051 sección H — ver comentario equivalente en ApplicationDefaultLayout.tsx:
// location.state?.resetVista se agrega a las dependencias para que este
// efecto vuelva a correr (y pise cualquier override de breadcrumb previo)
// cuando el remount forzado de RemoteApp (sección F) trae de vuelta al
// listado — sin esto, el override del detalle quedaba mostrándose.
function BreadcrumbBase() {
  const location = useLocation()
  const aplicacionActiva = useAplicacionActiva()
  const { setBreadcrumbs } = useBreadcrumbs()
  const resetVista = (location.state as { resetVista?: number } | null)?.resetVista

  useEffect(() => {
    if (!aplicacionActiva) return
    const vistaActiva = aplicacionActiva.vistas.find((v) =>
      location.pathname.endsWith(`/${v.path}`)
    )
    const items: BreadcrumbItem[] = [
      {
        label: aplicacionActiva.nombre,
        href: `/${aplicacionActiva.applicationId.toLowerCase()}`,
        icono: aplicacionActiva.icono
      }
    ]
    if (vistaActiva) {
      items.push({
        label: vistaActiva.label,
        href: `/${aplicacionActiva.applicationId.toLowerCase()}/${vistaActiva.path}`,
        icono: vistaActiva.icono
      })
    }
    setBreadcrumbs(items)
  }, [location.pathname, aplicacionActiva, setBreadcrumbs, resetVista])

  return null
}

export const ApplicationWideLayout: React.FC = () => {
  return (
    <BreadcrumbProvider>
      <BreadcrumbBase />
      <div className="flex h-screen flex-col bg-gray-50">
        <Header />

        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </BreadcrumbProvider>
  )
}
